import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useOrgs } from '@/context/OrgsProvider';

export const RequireOrg: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { orgsLoading, hasNoOrgs } = useOrgs();

  if (orgsLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (hasNoOrgs) {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
};
